import { useState, useCallback, useEffect } from "react"
import { APIError } from "../../app/modules/auth"
import { getLocationsNeedingAttention } from "../core/_requests"

const useLocationsNeedingAttention = (inCategory: 'event-admins' | 'event-checkins' | 'direct-mail' | 'passare' | 'fca' | 'online-arrangement' | 'webhooks') => {
    const [locationsNeedingAttention, setLocationsNeedingAttention] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    const loadLocationsNeedingAttention = useCallback(async () => {
        setLoading(true)
        try {
            const result = await getLocationsNeedingAttention(inCategory)
            setLocationsNeedingAttention(result)
        } catch (exception) {
            console.error(exception)
            const errorMessage =
                exception instanceof APIError ? exception.message : 'Failed to load locations needing attention';
            setErrorMessage(errorMessage);
        } finally {
            setLoading(false)
        }
    }, [inCategory])

    useEffect(() => {
        loadLocationsNeedingAttention()
    }, [loadLocationsNeedingAttention])

    return {
        locationsNeedingAttention,
        loading,
        errorMessage
    }
}

export default useLocationsNeedingAttention